import { createCoinElement } from "./single-coin.component";

export class SelectedCoinsComponent {

    private refreshButton: HTMLButtonElement;
    private coinsContainer: HTMLButtonElement;
    private initialCoinSelection: Set<any>;

    constructor(
        private rootElement: HTMLElement,
        private selectedCoins: Set<any>,
        private coinIdToCoinMap: Map<string, any>,
        private resetToInitialSelectionCb: () => void,
        private deselectCoinCb: (coinId: string) => void) {
            this.initialCoinSelection = new Set(selectedCoins);
            this.refreshButton = rootElement.querySelector('.refresh-coins')!;
            this.coinsContainer = rootElement.querySelector('.coins-selected-list')!;
            this.init();
            this.update();
    }

    init() {
        this.refreshButton.addEventListener('click', () => {
            this.resetToInitialSelectionCb();
        });
    }

    update() {
        const equalSets = (a, b) => a.size === b.size && [...a].every(value => b.has(value));
        const isDisabled = equalSets(this.selectedCoins, this.initialCoinSelection);
        this.refreshButton.disabled = isDisabled;
        this.refreshButton.classList.toggle('disabled', isDisabled);

        this.coinsContainer.innerHTML = '';
        this.selectedCoins.forEach(coinId => {
            const coinElement = createCoinElement(this.coinIdToCoinMap.get(coinId), 'selected', true, this.deselectCoinCb);
            this.coinsContainer.appendChild(coinElement);
        });
    }

}
